'use strict'

import {
    SIGNUPVALIDATION_FAIL,
    SIGNUPVALIDATION_SUCCESS
} from '../constants/SignUpValidationConstants'

export default function SignUpValidationReducer(state = {}, action) {
    switch (action.type) {
        case SIGNUPVALIDATION_FAIL: {
            return Object.assign({}, state, {
                error: action.error
            })
        }
        case SIGNUPVALIDATION_SUCCESS: {
            return Object.assign({}, state, {
                success: action.success
            })
        }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/signup/reducers/SignUpValidationReducer.js